import React, { ReactNode } from "react";

import Tooltip from "antd/es/tooltip";
import cn from "classnames";

import dragStyles from "@app/scene/dashboard/components/styles/common.module.scss";

import styles from "./BaseCard.module.scss";

interface Props {
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  draggable?: boolean;
  menu?: ReactNode;
  subtitle?: ReactNode;
  title: ReactNode;
  tooltip?: ReactNode;
}

const BaseCard: React.FC<Props> = ({
  actions,
  children,
  className,
  contentClassName,
  draggable,
  menu,
  subtitle,
  title,
  tooltip,
}) => {
  return (
    <div className={cn(styles.container, className)}>
      <div className={cn(styles.header, { [dragStyles.draggable]: draggable })}>
        <div className={styles.titleContainer}>
          <Tooltip mouseEnterDelay={1} placement="topLeft" title={tooltip ?? title}>
            <div className={styles.title}>{title}</div>
          </Tooltip>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
        <div className={cn(styles.actionsContainer, { [dragStyles.nonDraggable]: draggable })}>
          {actions && <div className={styles.actions}>{actions}</div>}
          {menu && <div className={styles.menu}>{menu}</div>}
        </div>
      </div>
      <div className={cn(styles.content, contentClassName)}>{children}</div>
    </div>
  );
};

export default BaseCard;
